































import { defineComponent, reactive, onBeforeMount } from '@vue/composition-api'

import { UserState, MonitorState } from '@/types/store'
import { UserRole, userTypes } from '@/types/user'
import useVuex from '@/utils/useVuex'

import Layout from '@/components/organisms/common/Layout.vue'
import { MonitorsTable } from '@/components/organisms/monitors'

export default defineComponent({
  name: 'Monitors',
  components: { Layout, MonitorsTable },
  setup(props, context) {
    const store = context.root.$store
    const state = reactive({
      monitors: useVuex<MonitorState['monitors']>(
        context,
        () => store.getters['monitor/monitors'],
      ),
      total: useVuex<MonitorState['total']>(
        context,
        () => store.getters['monitor/total'],
      ),
      isMonitorsLoading: useVuex<MonitorState['isMonitorsLoading']>(
        context,
        () => store.getters['monitor/isMonitorsLoading'],
      ),
      searchCondition: { id: '' },
      user: useVuex<UserState['user']>(
        context,
        () => store.getters['user/user'],
      ),
    })

    onBeforeMount(() => {
      store.dispatch('monitor/getMonitors', {
        id: state.searchCondition.id,
      })
    })

    const search = () => {
      store.dispatch('monitor/getMonitors', {
        id: state.searchCondition.id,
      })
    }

    return { state, search, UserRole, userTypes }
  },
})
